import React from 'react';
import { useLocation, Link } from 'react-router-dom';
import Header from '../Components/Header/Header';
import Footer from '../Components/Footer/Footer';
import { useAuthContext } from '../context/AuthContext';
import './OrderThankYou.css';

const OrderThankYou = () => {
    const location = useLocation();
    const { user } = useAuthContext();
    const { orderDetails } = location.state || {};

    const userName = user ? (user.firstName || user.username) : '';

    if (!orderDetails) {
        return (
            <div className="common-bg payment-status-page thank-you-page">
                <div className="container">
                    <Header title={userName ? `Hello ${userName}` : undefined} />
                    <div className="padding30"></div>
                    <div className="content-wrap white-bg">
                        <div className="content-wrap-inner subscription-form status-wrap">
                            <div className="head-title">Order Details Not Found</div>
                            <p className="sub-title-text mb---20">We could not find your recent order information in this session.</p>
                            <div className="thankyou-links mt---20">
                                <Link to="/dashboard"><button className="button-right-arrow hover-bounce">My Account <span className="arrow-right"></span></button></Link>
                                <Link to="/"><button className="button-right-arrow hover-bounce">Go to Home <span className="arrow-right"></span></button></Link>
                            </div>
                        </div>
                    </div>
                    <Footer />
                </div>
            </div>
        );
    }

    const {
        customerName,
        customerEmail,
        customerAddress,
        orderSummary = [],
        paymentDetails = {},
    } = orderDetails;

    const addressText = customerAddress
        ? `${customerAddress.line1 || ''}, ${customerAddress.city || ''}, ${customerAddress.state || ''} ${customerAddress.postal_code || ''}, ${customerAddress.country || ''}`
        : 'N/A';

    return (
        <div className="common-bg payment-status-page thank-you-page">
            <div className="container">
                <Header title={userName ? `Hello ${userName}` : undefined} />
                <div className="padding30"></div>
                <div className="content-wrap white-bg">
                    <div className="content-wrap-inner subscription-form status-wrap">
                        <div className="head-title">Thank You For Your Order</div>
                        <p className="sub-title-text mb---20">Your subscription is active and a confirmation has been sent to your email.</p>

                        <div className="subscription-item">
                            <div><span>Name :</span> {customerName || 'N/A'}</div>
                            <div><span>Email :</span> {customerEmail || 'N/A'}</div>
                            <div><span>Address :</span> {addressText}</div>
                        </div>

                        <div className="subscription-item">
                            <div><span>Order Summary :</span> {orderSummary.length ? `${orderSummary.length} item(s)` : 'N/A'}</div>
                            {orderSummary.map((item, index) => (
                                <div key={`${item.productName || 'item'}-${index}`}>
                                    <span>Item {index + 1} :</span> {item.productName || 'Product'} x {item.quantity || 1} (${item.price || '0'})
                                </div>
                            ))}
                        </div>

                        <div className="subscription-item">
                            <div><span>Payment Method :</span> {paymentDetails.method || 'N/A'}</div>
                            <div><span>Amount Paid :</span> ${paymentDetails.amount || '0'}</div>
                            <div><span>Transaction ID :</span> {paymentDetails.transactionId?.id || 'N/A'}</div>
                        </div>

                        <p className="footer-details">Questions? Reach us at <a href="mailto:info@copeahead.com">info@copeahead.com</a>.</p>

                        <div className="thankyou-links mt---20">
                            <Link to="/dashboard"><button className="theme-btn">Go to dashboard</button></Link>
                            <Link to="/"><button className="button-right-arrow hover-bounce">Go to home <span className="arrow-right"></span></button></Link>
                        </div>
                    </div>
                </div>
                <Footer />
            </div>
        </div>
    );
};

export default OrderThankYou;
